// removed by extract-text-webpack-plugin
module.exports = {"SaveForm":"SaveForm__SaveForm___1reQZ","SaveFormForm":"SaveForm__SaveFormForm___1lY7R","SaveFormImage":"SaveForm__SaveFormImage___2HbMC","SaveFormText":"SaveForm__SaveFormText___3j7Vr","requiredStar":"SaveForm__requiredStar___2ZA-d"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/SaveForm/SaveForm.less
// module id = 1204
// module chunks = 0 1